import { FloatingSection } from '@abyss/web/ui/FloatingSection';
import React, { useEffect } from 'react';

import {
  providerFloatDesktopOpen,
  providerFloatMobile,
} from '../../../../common/ConstantsStyles';
import { shouldUseGehaV2Styling } from '../../../../utils/gehaThemeUtils';
import { CompareDrawer } from '../MapView/CompareDrawer';
import { CompareDrawerMobile } from '../MapView/CompareDrawer/CompareDrawerMobile';

type Props = {
  openCompare: boolean;
  mobileScreen: boolean;
  selectedItems: any;
  items: any;
  removeItem: any;
  map: any;
  headers: any;
  setOpenCompare: any;
  setSelectedCheckbox: any;
  setSelectedItems: any;
  setItems: any;
  containerRef: React.RefObject<HTMLDivElement>;
  selectedCheckbox: any;
  showMergedCompareAndShare: boolean;
  compareShareToggle?: boolean;
  setCompareShareToggle?: (a: boolean) => void;
  setIsCompareClicked?: (a: boolean) => void;
  urlCheck: boolean;
  recommendationPreferences?: any;
  isTieredPlan?: boolean;
};

export const ShowCompareFloatingSection = ({
  removeItem,
  selectedCheckbox,
  setSelectedCheckbox,
  openCompare,
  containerRef,
  mobileScreen,
  setOpenCompare,
  headers,
  items,
  selectedItems,
  setItems,
  setSelectedItems,
  map,
  compareShareToggle,
  setCompareShareToggle,
  showMergedCompareAndShare,
  setIsCompareClicked,
  urlCheck,
  recommendationPreferences,
  isTieredPlan,
}: Props) => {
  useEffect(() => {
    const intervalId = setInterval(() => {
      // CompareFloatingSection setting body overflow hidden unexpectedly
      if (document.body.style.overflow === 'hidden') {
        document.body.style.overflow = '';
      }
    }, 1000);
    return () => clearInterval(intervalId);
  }, [openCompare]);

  if (!openCompare) return null;

  const handleClose = () => {
    setOpenCompare(false);
    setSelectedCheckbox({ ...selectedCheckbox });
  };

  const isGEHAV2 = shouldUseGehaV2Styling();

  const getFloatingSectionCss = () => {
    if (showMergedCompareAndShare && mobileScreen)
      return {
        ...providerFloatMobile,
        'abyss-floating-section-root': {
          backgroundColor: isGEHAV2 ? '#CAD9E2' : '#EEF8FB !important',
          ...providerFloatMobile['abyss-floating-section-root'],
          bottom: 0,
          paddingBottom: '0px',
          borderRadius: '0px',
          '@media (max-width: 743px) and (orientation: landscape)': {
            position: 'relative',
            bottom: '',
            top: 0,
          },
        },
      };
    if (mobileScreen) return providerFloatMobile;

    if (showMergedCompareAndShare && compareShareToggle) {
      return {
        ...providerFloatDesktopOpen,
        'abyss-floating-section-root': {
          backgroundColor: isGEHAV2 ? '#CAD9E2' : '#EEF8FB !important',
          ...providerFloatDesktopOpen['abyss-floating-section-root'],
          bottom: undefined,
          paddingBottom: '0px',
          top: urlCheck ? '48px' : '0px',
          position: 'sticky',
          borderRadius: '0px',
        },
      };
    }

    return providerFloatDesktopOpen;
  };

  const renderDrawer = () => {
    const commonProps = {
      headers,
      items,
      removeItem,
      selectedCount: selectedItems.length,
      selectedProviders: selectedItems,
      setCompareShareToggle,
      setItems,
      setOpenCompare,
      setSelectedCheckbox,
      setSelectedProviders: setSelectedItems,
      showMergedCompareAndShare,
      total: 5,
      setIsCompareClicked,
      recommendationPreferences,
      isTieredPlan,
    };

    return mobileScreen ? (
      <CompareDrawerMobile
        {...commonProps}
        data-auto-testid="drawer-compare"
        data-testid="drawer-compare"
      />
    ) : (
      <CompareDrawer
        {...commonProps}
        data-auto-testid="drawer-compare"
        data-testid="drawer-compare"
        map={map}
      />
    );
  };

  return (
    <FloatingSection
      containerRef={containerRef}
      css={getFloatingSectionCss()}
      data-auto-testid={
        showMergedCompareAndShare && compareShareToggle
          ? 'mapview-compare-drawer-with-blue-background'
          : 'mapview-compare-drawer'
      }
      data-testid={
        showMergedCompareAndShare && compareShareToggle
          ? 'mapview-compare-drawer-with-blue-background'
          : 'mapview-compare-drawer'
      }
      isOpen={openCompare}
      onClose={handleClose}
      size={mobileScreen ? window.innerHeight - 104 : 464}
    >
      {renderDrawer()}
    </FloatingSection>
  );
};
